var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crud"},[_c('the-crud',{attrs:{"title":_vm.title,"store":_vm.store,"columns":_vm.columns,"search":_vm.search,"canDelete":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }